import { baseApi } from './baseApi';
import {
    CONFIG_API_URLS,
    is_api_error_last_cache,
    KEY_HOST_CACHE_NEXT_API,
    parseUrlsApi,
    remove_all_host_cache,
    set_host_cache,
    set_host_error_last_cache,
} from 'utils/getConfigUrls';
import { GET_API_MICROSERVICE } from '../../config';
import { sentEventSentry } from 'core/Sentry/lib/sentEventSentry';

function change_api_domain() {
    const init = () => {
        const JSONData = window.localStorage.getItem(KEY_HOST_CACHE_NEXT_API);

        if (!JSONData) {
            const freeDomains = Object.keys(parseUrlsApi(CONFIG_API_URLS)).map((item) => {
                return {
                    [item]: true,
                };
            });

            window.localStorage.setItem(KEY_HOST_CACHE_NEXT_API, JSON.stringify(freeDomains));
        }
    };

    if (is_api_error_last_cache()) {
        remove_all_host_cache();
        init();
    }

    return {
        init: init,

        getNext() {
            const JSONData = window.localStorage.getItem(KEY_HOST_CACHE_NEXT_API);

            if (JSONData) {
                try {
                    const data = JSON.parse(JSONData);

                    if (Array.isArray(data)) {
                        const domain_api = data.reduce((state, item) => {
                            const [key, value] = Object.entries(item)[0];

                            if (!state && value) {
                                state = key;
                            }

                            return state;
                        }, '');

                        if (domain_api) return domain_api;

                        return '';
                    }
                } catch (e) {
                    return '';
                }
            }

            return '';
        },

        update(key, value) {
            const JSONData = window.localStorage.getItem(KEY_HOST_CACHE_NEXT_API);

            if (JSONData) {
                try {
                    let data = JSON.parse(JSONData);

                    if (Array.isArray(data)) {
                        data = data.map((item) => {
                            const [key_local] = Object.entries(item)[0];

                            if (key_local === key) {
                                item[key] = value;
                            }

                            return item;
                        });

                        window.localStorage.setItem(KEY_HOST_CACHE_NEXT_API, JSON.stringify(data));
                    }
                } catch (e) {}
            }
        },

        initNextDomain(error) {
            this.init();

            const freeDomainKey = this.getNext();

            if (freeDomainKey) {
                this.update(freeDomainKey, false);
                set_host_cache(freeDomainKey);
                window.publicApiReact?.WebSocket.reinit();

                sentEventSentry({
                    event: '[API] change_api',
                    name: 'api:change_domain',
                    level: 'log',
                    error: error,
                });

                if (!error.config) return Promise.reject(error);

                error.config.baseURL = GET_API_MICROSERVICE();

                return baseApi.request(error.config);
            }

            set_host_error_last_cache('1');

            return Promise.reject(error);
        },
    };
}

export const change_auth_domain_api = change_api_domain();

change_auth_domain_api.init();
